import { render, staticRenderFns } from "./LeadActions.vue?vue&type=template&id=40a2f9dc&"
import script from "./LeadActions.vue?vue&type=script&lang=ts&"
export * from "./LeadActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports